export enum AuthState {
  ready = 'authorizationStateReady',
  phone = 'authorizationStateWaitPhoneNumber',
  code = 'authorizationStateWaitCode',
  password = 'authorizationStateWaitPassword',
  registration = 'authorizationStateWaitRegistration',
  logout = 'authorizationStateLoggingOut',
  close = 'authorizationStateClosed'
}

export enum ConnectionState {
  connecting = 'connectionStateConnecting',
  proxy = 'connectionStateConnectingToProxy',
  updating = 'connectionStateUpdating',
  network = 'connectionStateWaitingForNetwork',
  ready = 'connectionStateReady'
}
